import React, { Component, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';

const Home = React.lazy(() => import('./components/Home'));
const Login = React.lazy(() => import('./components/Login'));
const Posts = React.lazy(() => import('./components/Posts'));
const FormResualts = React.lazy(() => import('./components/FormResualts'));
const ModuleDesginer = React.lazy(() => import('./components/ModuleDesginer'));
const Post = React.lazy(() => import('./components/Post'));
const Comments = React.lazy(() => import('./components/Comments'));
const Comment = React.lazy(() => import('./components/Comment'));
const NewsLetters = React.lazy(() => import('./components/NewsLetters'));
const NewsLetter = React.lazy(() => import('./components/NewsLetter'));
const Users = React.lazy(() => import('./components/Users'));
const Customers = React.lazy(() => import('./components/Customers'));
const Customer = React.lazy(() => import('./components/Customer'));
const FM = React.lazy(() => import('./components/FM'));
const Profile = React.lazy(() => import('./components/Profile'));
const Settings = React.lazy(() => import('./components/Settings'));
const PostAttributes = React.lazy(() => import('./components/PostAttributes'));
const PostAttribute = React.lazy(() => import('./components/PostAttribute'));
const Stores = React.lazy(() => import('./components/Stores'));
const Store = React.lazy(() => import('./components/Store'));
const UserGroups = React.lazy(() => import('./components/UserGroups'));
const ShopOrdersList = React.lazy(() => import('./components/Shop/OrdersList'));
const ShopOrder = React.lazy(() => import('./components/Shop/Order'));
const GoldStoreOrdersList = React.lazy(() => import('./components/GoldStore/OrdersList'));
const GoldStoreOrder = React.lazy(() => import('./components/GoldStore/Order'));
const FastUpdate = React.lazy(() => import('./components/FastUpdate'));

const InsuranceRate = React.lazy(() => import('./components/Shop/InsuranceRate'));
const InsuranceRates = React.lazy(() => import('./components/Shop/InsuranceRates'));
const ShipmentMethod = React.lazy(() => import('./components/Shop/ShipmentMethod'));
const ShipmentMethods = React.lazy(() => import('./components/Shop/ShipmentMethods'));
const ShippingZone = React.lazy(() => import('./components/Shop/ShippingZone'));
const ShippingZones = React.lazy(() => import('./components/Shop/ShippingZones'));

const CustomerGroups = React.lazy(() => import('./components/CustomerGroups'));
const PriceGroups = React.lazy(() => import('./components/PriceGroups'));
const BankAccounts = React.lazy(() => import('./components/GoldStore/BankAccounts'));
const Deposits = React.lazy(() => import('./components/GoldStore/Deposits'));
const GoldStoreSettings = React.lazy(() => import('./components/GoldStore/GoldStoreSettings'));

{/*stone component*/ }
const Types = React.lazy(() => import('./components/Stone/Types'));
const Kinds = React.lazy(() => import('./components/Stone/Kinds'));
const Weights = React.lazy(() => import('./components/Stone/Weights'));
const Sizes = React.lazy(() => import('./components/Stone/Sizes'));
const Colors = React.lazy(() => import('./components/Stone/Colors'));

const Stones = React.lazy(() => import('./components/Stone/Stones'));
const StonesToAcc = React.lazy(() => import('./components/Stone/StonesToAcc'));
const StonesToStore = React.lazy(() => import('./components/Stone/StonesToStore'));
const StonesReport = React.lazy(() => import('./components/Stone/StonesReport'));

const Shemshes = React.lazy(() => import('./components/Stone/Shemshes'));
const ShemshesToAcc = React.lazy(() => import('./components/Stone/ShemshesToAcc'));
const ShemshesToStore = React.lazy(() => import('./components/Stone/ShemshesToStore'));
const ShemshesReport = React.lazy(() => import('./components/Stone/ShemshesReport'));

const Sachmes = React.lazy(() => import('./components/Stone/Sachmes'));
const SachmesToAcc = React.lazy(() => import('./components/Stone/SachmesToAcc'));
const SachmesToStore = React.lazy(() => import('./components/Stone/SachmesToStore'));
const SachmesReport = React.lazy(() => import('./components/Stone/SachmesReport'));

const Luxurious = React.lazy(() => import('./components/Stone/Luxurious'));
const LuxuriousToAcc = React.lazy(() => import('./components/Stone/LuxuriousToAcc'));
const LuxuriousToStore = React.lazy(() => import('./components/Stone/LuxuriousToStore'));
const LuxuriousReport = React.lazy(() => import('./components/Stone/LuxuriousReport'));

const Requests = React.lazy(() => import('./components/Stone/Requests'));
const Applicants = React.lazy(() => import('./components/Stone/Applicants'));
const StuffTypes = React.lazy(() => import('./components/Stone/StuffTypes'));
const Jenses = React.lazy(() => import('./components/Stone/Jenses'));
const Rings = React.lazy(() => import('./components/Stone/Rings'));
const Transparencies = React.lazy(() => import('./components/Stone/Transparencies'));
const Origins = React.lazy(() => import('./components/Stone/Origins'));
const Templates = React.lazy(() => import('./components/Stone/Templates'));
const Websites = React.lazy(() => import('./components/Stone/Websites'));

{/*gold store component*/ }
const CustomerGroupRates = React.lazy(() => import('./components/GoldStore/CustomerGroupRates'));
const Symbols = React.lazy(() => import('./components/GoldStore/Symbols'));
const Timing = React.lazy(() => import('./components/GoldStore/Timing'));

/*acc Components*/
const Factors = React.lazy(() => import('./components/Acc/Factors'));
const Receipts = React.lazy(() => import('./components/Acc/Receipts'));
const CashDesks = React.lazy(() => import('./components/Acc/CashDesks'));

const Remittances = React.lazy(() => import('./components/Acc/Remittances'));
const Remittance = React.lazy(() => import('./components/Acc/Remittance'));
const StuffCardex = React.lazy(() => import('./components/Acc/StuffCardex'));
const Warehouses = React.lazy(() => import('./components/Acc/Warehouses'));

const Chats = React.lazy(() => import('./components/Chats/Chats'));
const Chat = React.lazy(() => import('./components/Chats/Chat'));

class App extends Component {
    constructor(props) {
        super(props);
    }

    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }

    render() {
        return <Layout>
            <Suspense fallback={<div></div>}>
                <Routes basename="/profile/">
                    <Route path="/dashboard" element={<Home />}></Route>
                    <Route path="/login/" element={<Login />}></Route>

                    <Route path='/cashdesks' element={<CashDesks />} />

                    <Route path='/chats' element={<Chats />} />
                    <Route path='/chat' element={<Chat />} />

                    <Route path='/receipts' element={<Receipts Type={0} />} />
                    <Route path='/receipts/in' element={<Receipts Type={1} />} />
                    <Route path='/receipts/out' element={<Receipts Type={2} />} />

                    <Route path='/factors/buy' element={<Factors Type={1} />} />
                    <Route path='/factors/sale' element={<Factors Type={2} />} />
                    <Route path='/factors/buyreturn' element={<Factors Type={3} />} />
                    <Route path='/factors/salereturn' element={<Factors Type={4} />} />
                    <Route path='/factors/waste' element={<Factors Type={5} />} />

                    <Route path='/remittance/edit/:id' element={<Remittance Id={1} />} />
                    <Route path='/remittances/out' element={<Remittances IO={2} />} />
                    <Route path='/remittances/in' element={<Remittances IO={1} />} />
                    <Route path='/remittances/transfer' element={<Remittances IO={3} />} />
                    <Route path='/stuff/cardex' element={<StuffCardex />} />

                    <Route path='/warehouses' element={<Warehouses />} />

                    <Route path="/moduledesginer/" element={<ModuleDesginer />}></Route>

                    <Route path="/comments/" element={<Comments />}></Route>
                    <Route path='/comments/edit/:id/' element={<Comment id={1} />} />

                    <Route path="/shop/fast/update/" element={<FastUpdate />}></Route>

                    <Route path="/shop/orders/" element={<ShopOrdersList />}></Route>
                    <Route path="/shop/orders/new/" element={<ShopOrder id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/orders/edit/:id/' element={<ShopOrder id={1} />} />

                    <Route path="/goldstore/orders/" element={<GoldStoreOrdersList />}></Route>
                    <Route path="/goldstore/orders/new/" element={<GoldStoreOrder id={this.getDefaultGuid()} />}></Route>
                    <Route path='/goldstore/orders/edit/:id/' element={<GoldStoreOrder id={1} />} />

                    <Route path="/shop/stores/" element={<Stores Type={1} />}></Route>
                    <Route path="/shop/stores/new/" element={<Store Type={1} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/stores/edit/:id/' element={<Store Type={1} id={1} />} />

                    <Route path="/news/" element={<Posts Type={1} />}></Route>
                    <Route path="/news/new/" element={<Post Type={1} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/news/edit/:id/' element={<Post Type={1} id={1} />} />

                    <Route path="/blogs/" element={<Posts Type={2} />}></Route>
                    <Route path="/blogs/new/" element={<Post Type={2} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/blogs/edit/:id/' element={<Post Type={2} id={1} />} />

                    <Route path="/pages/" element={<Posts Type={3} />}></Route>
                    <Route path="/pages/new/" element={<Post Type={3} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/pages/edit/:id/' element={<Post Type={3} id={1} />} />

                    <Route path="/tags/" element={<Posts Type={4} />}></Route>
                    <Route path="/tags/new/" element={<Post Type={4} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/tags/edit/:id/' element={<Post Type={4} id={1} />} />

                    <Route path="/blogcategories/" element={<Posts Type={5} />}></Route>
                    <Route path="/blogcategories/new/" element={<Post Type={5} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/blogcategories/edit/:id/' element={<Post Type={5} id={1} />} />

                    <Route path="/newscategories/" element={<Posts Type={6} />}></Route>
                    <Route path="/newscategories/new/" element={<Post Type={6} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/newscategories/edit/:id/' element={<Post Type={6} id={1} />} />

                    <Route path="/menus/" element={<Posts Type={8} />}></Route>
                    <Route path="/menus/new/" element={<Post Type={8} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/menus/edit/:id/' element={<Post Type={8} id={1} />} />

                    <Route path="/ads/" element={<Posts Type={9} />}></Route>
                    <Route path="/ads/new/" element={<Post Type={9} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/ads/edit/:id/' element={<Post Type={9} id={1} />} />

                    <Route path="/products/" element={<Posts Type={10} />}></Route>
                    <Route path="/products/new/" element={<Post Type={10} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/products/edit/:id/' element={<Post Type={10} id={1} />} />

                    <Route path="/productcategories/" element={<Posts Type={11} />}></Route>
                    <Route path="/productcategories/new/" element={<Post Type={11} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/productcategories/edit/:id/' element={<Post Type={11} id={1} />} />

                    <Route path="/services/" element={<Posts Type={12} />}></Route>
                    <Route path="/services/new/" element={<Post Type={12} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/services/edit/:id/' element={<Post Type={12} id={1} />} />

                    <Route path="/servicecategories/" element={<Posts Type={13} />}></Route>
                    <Route path="/servicecategories/new/" element={<Post Type={13} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/servicecategories/edit/:id/' element={<Post Type={13} id={1} />} />

                    <Route path="/sliders/" element={<Posts Type={14} />}></Route>
                    <Route path="/sliders/new/" element={<Post Type={14} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/sliders/edit/:id/' element={<Post Type={14} id={1} />} />

                    <Route path="/shop/categories/" element={<Posts Type={15} />}></Route>
                    <Route path="/shop/categories/new/" element={<Post Type={15} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/categories/edit/:id/' element={<Post Type={15} id={1} />} />

                    <Route path="/shop/products/" element={<Posts Type={16} />}></Route>
                    <Route path="/shop/products/new/" element={<Post Type={16} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/products/edit/:id/' element={<Post Type={16} id={1} />} />

                    <Route path="/shop/tags/" element={<Posts Type={17} />}></Route>
                    <Route path="/shop/tags/new/" element={<Post Type={17} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/tags/edit/:id/' element={<Post Type={17} id={1} />} />

                    <Route path="/redirects/" element={<Posts Type={18} />}></Route>
                    <Route path="/redirects/new/" element={<Post Type={18} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/redirects/edit/:id/' element={<Post Type={18} id={1} />} />

                    <Route path="/shop/brands/" element={<Posts Type={19} />}></Route>
                    <Route path="/shop/brands/new/" element={<Post Type={19} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/brands/edit/:id/' element={<Post Type={19} id={1} />} />

                    <Route path="/shop/attributes/" element={<PostAttributes />}></Route>
                    <Route path="/shop/attributes/new/" element={<PostAttribute id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/attributes/edit/:id/' element={<PostAttribute id={1} />} />

                    <Route path="/magazines/" element={<Posts Type={21} />}></Route>
                    <Route path="/magazines/new/" element={<Post Type={21} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/magazines/edit/:id/' element={<Post Type={21} id={1} />} />

                    <Route path="/shop/stores/categories/" element={<Posts Type={23} />}></Route>
                    <Route path="/shop/stores/categories/new/" element={<Post Type={23} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/stores/categories/edit/:id/' element={<Post Type={23} id={1} />} />

                    <Route path="/templates/" element={<Posts Type={25} />}></Route>
                    <Route path="/templates/new/" element={<Post Type={25} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/templates/edit/:id/' element={<Post Type={25} id={1} />} />

                    <Route path="/forms/" element={<Posts Type={24} />}></Route>
                    <Route path="/forms/new/" element={<Post Type={24} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/forms/edit/:id/' element={<Post Type={24} id={1} />} />
                    <Route path='/forms/resualts/:id/' element={<FormResualts />} />
                    
                    <Route path="/shop/guarantees/" element={<Posts Type={26} />}></Route>
                    <Route path="/shop/guarantees/new/" element={<Post Type={26} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/guarantees/edit/:id/' element={<Post Type={26} id={1} />} />

                    <Route path="/minutes/" element={<Posts Type={27} />}></Route>
                    <Route path="/minutes/new/" element={<Post Type={27} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/minutes/edit/:id/' element={<Post Type={27} id={1} />} />

                    <Route path="/minutes/categories/" element={<Posts Type={30} />}></Route>
                    <Route path="/minutes/categories/new/" element={<Post Type={30} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/minutes/categories/edit/:id/' element={<Post Type={30} id={1} />} />

                    <Route path="/projects/" element={<Posts Type={28} />}></Route>
                    <Route path="/projects/new/" element={<Post Type={28} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/projects/edit/:id/' element={<Post Type={28} id={1} />} />

                    <Route path="/projects/categories/" element={<Posts Type={29} />}></Route>
                    <Route path="/projects/categories/new/" element={<Post Type={29} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/projects/categories/edit/:id/' element={<Post Type={29} id={1} />} />

                    <Route path="/meetings/" element={<Posts Type={31} />}></Route>
                    <Route path="/meetings/new/" element={<Post Type={31} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/meetings/edit/:id/' element={<Post Type={31} id={1} />} />

                    <Route path="/resumes/" element={<Posts Type={32} />}></Route>
                    <Route path="/resumes/new/" element={<Post Type={32} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/resumes/edit/:id/' element={<Post Type={32} id={1} />} />

                    <Route path="/shop/shipmentmethods/" element={<ShipmentMethods />}></Route>
                    <Route path="/shop/shipmentmethods/new/" element={<ShipmentMethod id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/shipmentmethods/edit/:id/' element={<ShipmentMethod id={1} />} />

                    <Route path="/shop/insurancerates/" element={<InsuranceRates />}></Route>
                    <Route path="/shop/insurancerates/new/" element={<InsuranceRate id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/insurancerates/edit/:id/' element={<InsuranceRate id={1} />} />

                    <Route path="/shop/shippingzones/" element={<ShippingZones />}></Route>
                    <Route path="/shop/shippingzones/new/" element={<ShippingZone id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/shippingzones/edit/:id/' element={<ShippingZone id={1} />} />

                    <Route path="/users/" element={<Users />}></Route>

                    <Route path="/customers/" element={<Customers />}></Route>
                    <Route path="/customers/new/" element={<Customer id={this.getDefaultGuid()} />}></Route>
                    <Route path='/customers/edit/:id/' element={<Customer id={1} />} />

                    <Route path="/newsletters/" element={<NewsLetters />}></Route>
                    <Route path="/newsletters/new/" element={<NewsLetter id={this.getDefaultGuid()} />}></Route>
                    <Route path='/newsletters/edit/:id/' element={<NewsLetter id={1} />} />

                    <Route path='/fm' element={<FM />} />

                    <Route path='/profile' element={<Profile />} />
                    <Route path='/settings' element={<Settings />} />

                    <Route path='/usergroups' element={<UserGroups />} />
                    <Route path='/customergroups' element={<CustomerGroups />} />
                    <Route path='/pricegroups' element={<PriceGroups />} />
                    <Route path='/bankaccounts' element={<BankAccounts />} />
                    <Route path='/deposits' element={<Deposits />} />
                    <Route path='/goldstoresettings' element={<GoldStoreSettings />} />
                    
                    {/*gold store components*/}
                    <Route path='/customergrouprates' element={<CustomerGroupRates />} />
                    <Route path='/symbols' element={<Symbols />} />
                    <Route path='/timing' element={<Timing />} />

                    {/*stone component*/}
                    <Route path='/types' element={<Types />} />
                    <Route path='/kinds' element={<Kinds />} />
                    <Route path='/weights' element={<Weights />} />
                    <Route path='/sizes' element={<Sizes />} />
                    <Route path='/colors' element={<Colors />} />


                    <Route path='/luxurious/:templateId' element={<Luxurious />} />
                    <Route path='/luxurious/acc/:templateId' element={<LuxuriousToAcc />} />
                    <Route path='/luxurious/store/:templateId' element={<LuxuriousToStore />} />
                    <Route path='/luxurious/report' element={<LuxuriousReport />} />
                                        
                    <Route path='/requests' element={<Requests />} />

                    <Route path='/stones/:templateId' element={<Stones />} />
                    <Route path='/stones/acc/:templateId' element={<StonesToAcc />} />
                    <Route path='/stones/store/:templateId' element={<StonesToStore />} />
                    <Route path='/stones/report' element={<StonesReport />} />

                    <Route path='/shemshes/:templateId' element={<Shemshes />} />
                    <Route path='/shemshes/acc/:templateId' element={<ShemshesToAcc />} />
                    <Route path='/shemshes/store/:templateId' element={<ShemshesToStore />} />
                    <Route path='/shemshes/report' element={<ShemshesReport />} />

                    <Route path='/sachmes/:templateId' element={<Sachmes />} />
                    <Route path='/sachmes/acc/:templateId' element={<SachmesToAcc />} />
                    <Route path='/sachmes/store/:templateId' element={<SachmesToStore />} />
                    <Route path='/sachmes/report' element={<SachmesReport />} />

                    <Route path='/applicants' element={<Applicants />} />
                    <Route path='/jenses' element={<Jenses />} />
                    <Route path='/stufftypes' element={<StuffTypes />} />
                    <Route path='/rings' element={<Rings />} />
                    <Route path='/transparency' element={<Transparencies />} />
                    <Route path='/origins' element={<Origins />} />
                    <Route path='/websites' element={<Websites />} />
                    <Route path='/stonetemplates' element={<Templates />} />

                    <Route path="*" element={<Navigate to="/dashboard/" />}></Route>
                </Routes>
            </Suspense>
        </Layout>
    }
}

export default App;
